export enum TrackerCustomEvent {
  /** pad端崩溃日志上报 */
  CrashLog = 'crash-log',
  /** 设备信息 */
  DeviceInfo = 'device-info',
  /** 设备内存监测 */
  DeviceMemoryMonitor = 'device-memory-monitor',
  /** 获取安卓ID失败事件 */
  GetAndroidIdError = 'get-android-id-error',
  /** 点击【帮助反馈】 */
  HelpFeedbackClk = 'help-feedback-clk',
  /** 点击【问题反馈】 */
  IssueFeedbackClk = 'issue-feedback-clk',
  /** 点击【立即上报】 */
  ReportIssueClk = 'report-issue-clk',
  /** 点击【问题处理进度】 */
  IssueProgressClk = 'issue-progress-clk',
  /** 点击【提交】 */
  SubmitIssueClk = 'submit-issue-clk',
  /** 点击【快速指南】 */
  QuickGuideClk = 'quick-guide-clk',
  /** 点击【使用技巧】 */
  UsingSkillClk = 'using-skill-clk',
  /** 点击【一指禅视频】 */
  YzcSkillVideoClk = 'yzc-skill-video-clk',
  /** 点击【射频视频】 */
  RfSkillVideoClk = 'rf-skill-video-clk',
  /** 点击【冲击波视频】 */
  SwSkillVideoClk = 'sw-skill-video-clk',
  /** 点击【矩阵艾灸视频】 */
  MoxSkillVideoClk = 'mox-skill-video-clk',
  /** 点击【热砭石视频】 */
  HotstoneSkillVideoClk = 'hotstone-skill-video-clk',
  /** 点击【常见问题】 */
  CommonProblemClk = 'common-problem-clk',
  /** 点击【版本说明】 */
  ReleaseNoteClk = 'release-note-clk',
  /** 点击【使用说明书】 */
  UseDescClk = 'use-desc-clk',
  /** 打开摄像头失败的日志 */
  OpenCameraError = 'open-camera-error',
  /** 按摩页面点击查看方案详情 */
  MassagePlanDetailsClk = 'massage-plan-details-clk',
  /** 查看会员档案详情 */
  ViewMemberInfoClk = 'view-member-info-clk',
  /** 编辑会员档案 */
  EditMemberInfoClk = 'edit-member-info-clk',
  /** 更新会员档案 */
  UpdateMemberInfoClk = 'update-member-info-clk',
  /** 设备因权限位置获取不到GPS信息导致内存异常 */
  DeviceGPSAbnormal = 'device-gps-abnormal',
  /** WIFI和基站定位获取失败 */
  GetWifiLocError = 'get-wifi-loc-error',
  /** 局域网连接错误 */
  LanConnectError = 'lan-connect-error',
  /** WIFI和基站定位信息 */
  WifiLocationInfo = 'wifi-location-info',
  /** 门店点击不同的时间维度去查看服务记录 */
  ServiceRecordByTimeDimensionClk = 'service-record-dimensions-clk',
  /** 会员记录-排序规则 */
  ViewMemberRecordSortClk = 'view-member-record-sort-clk',
  /** 服务详情-点击会员记录页面 */
  ViewMemberRecordClk = 'view-member-record-clk',
  /** 会员记录-会员消费详情 */
  MemberConsumptionDetailClk = 'member-consumption-detail-clk',
  /** 理疗档案 内源热能测量数据&&来源 */
  FillInPhysicalInfoSource = 'fill-in-physical-info-source',
  /** 查看用户单次理疗记录的效果记录 进行前后对比 */
  ViewMemberEffectRecordClk = 'view-member-effect-record-clk',
  /** 展开用户理疗诉求 */
  ViewMemberTherapyAppealClk = 'view-member-therapy-appeal-clk',
  /** 点击去AI问诊 */
  AiConsultationClk = 'ai-consultation-clk',
  /** 【推荐方案】点击去理疗 */
  RecommendToTherapy = 'recommend-to-therapy',
  /** 跳过舌诊/症状确认 */
  AiConsultationSkipClk = 'ai-consultation-skip-clk',
  /**  每个提示建议的反馈情况 */
  SuggestionsForFeedback = 'suggestions-for-feedback',
  /**  记录免责条款信息 */
  RecordInfoDisclaimerClause = 'record-info-disclaimer-clause',
  //服务记录页面
  //出现该弹窗的总次数
  ServiceRecordDrawerAlertShow = 'service-record-drawer-show',
  // 成功提交的次数
  ServiceRecordDrawerAlertSubmit = 'service-record-drawer-submit',
  // 点击跳过的次数
  ServiceRecordDrawerAlertSkip = 'service-record-drawer-skip',
  // 服务记录点击次数
  ServiceRecordDrawerShowTimes = 'service-record-card-click',
  // 离开服务记录页面时相关埋点
  LeaveServiceRecordPage = 'leave-service-record-page',
  // 单次进入服务页面点击去补充的次数
  GoServiceRecordDrawerSupplyButton = 'go-record-drawer-supply-click',
  // R2预热信息点击埋点
  R2PreheatClick = 'r2-preheat-click',
  // 收到异常事件捕获
  ReceiveExceptionEventCapture = 'receive-exception-event-capture',
  // 异常事件恢复
  ExceptionEventRecovery = 'exception-event-recovery',
}

export enum ViewMemberInfoScene {
  MemberDetail = 'member-detail',
  Massage = 'massage',
}

export enum EditMemberInfoScene {
  SearchMember = 'search-member',
  MemberDetail = 'member-detail',
}

export enum PhysicalInfoDimension {
  'waistCircumference' = '腰围',
  'backThickness' = '背厚',
  'leftArmCircumference' = '左臂围',
  'rightArmCircumference' = '右臂围',
  'leftThighCircumference' = '左大腿围',
  'rightThighCircumference' = '右大腿围',
  'leftCalfCircumference' = '左小腿围',
  'rightCalfCircumference' = '右小腿围',
  'painLevel' = '疼痛严重程度',
  'physicalLevel' = '体质严重程度',
}

export enum PhysicalInfoSource {
  'ai-consultation' = 'AI问询',
  'physiotherapy-record-before' = '理疗前记录',
  'physiotherapy-record-after' = '理疗后记录',
  'member-info-edit' = '会员档案编辑',
}

export enum AIConsultationFrom {
  Home = 'home',
  MemberEdit = 'member-edit',
  MemberDetail = 'member-detail',
}

export enum RecommendToTherapyFrom {
  /** AI问诊结果页 */
  AiConsultationResult = 'ai-consultation-result',
  /** 健康档案 */
  HealthRecord = 'health-record',
}

export enum IConsultationSkip {
  /** AI问诊结果页 */
  tongueDiagnose = '舌诊',
  /** 健康档案 */
  issueConfirm = '症状确认',
}

export enum HelpInPhysiotherapyStage {
  'order-before' = '末端取下注意事项-下单前',
  'physical-therapy-notes' = '理疗操作温馨提示',
  'install-end-head' = '安装理疗末端-末端头',
  'install-wire' = '安装理疗末端-电线',
  'visual-check' = '人体检测中',
  'visual-error' = '人体检测异常',
  'remove-moxibustion-head' = '卸下艾灸头注意事项-订单结束',
  'remove-massage-head' = '卸下理疗末端-订单结束',
  'massage-visual-check' = '按摩中人体检测【暂停开始阶段】',
  'massage-visual-error' = '按摩中人体检测异常【暂停开始阶段】',
}
